import { gql } from '@apollo/client';

export const SEND_VERIFICATION_REQUEST = gql`
  mutation consumerSendApprovalRequest($customerId: ID!) {
    consumerSendApprovalRequest(customerId: $customerId){
        success
        message
    }
  }
`;